import { render, staticRenderFns } from "./TreemapAreaExpense.vue?vue&type=template&id=b1d45ab0&lang=pug&"
import script from "./TreemapAreaExpense.vue?vue&type=script&lang=ts&"
export * from "./TreemapAreaExpense.vue?vue&type=script&lang=ts&"
import style0 from "./TreemapAreaExpense.vue?vue&type=style&index=0&id=b1d45ab0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports